import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default function () {
  useGSAP(() => {
    let tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: 'power1.inOut',
        // repeat: -1,
      },
      scrollTrigger: {
        trigger: "#icon-bell",
        start: "top bottom-=100px",
        end: "bottom+=50px bottom",
        markers: false,
        toggleActions: "play none play reset"
      }
    });

    tl.addLabel("start")
      .to('#bell', { 
        rotate: -15,
        ease: 'power1.inOut',
        transformOrigin: 'center top' 
      })
      .to('#bell', { 
        rotate: 8,
      })
      .to('#bell', { 
        rotate: -10,
      })
      .to('#bell', { 
        rotate: 5,
      })
      .to('#bell', {
        rotate: 0,
      })
    });

 return (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110" id="icon-bell">
  <g fill="none" stroke="#001e5d" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.26" data-name="calendar notification date event">
      <path d="M11.56 56.61V24.43h93.32v46.66l-17.7 17.7H53.39" />
      <path d="M87.18 88.79v-17.7h17.7M37.3 14.77c0 1.78-1.44 3.22-3.22 3.22s-3.22-1.44-3.22-3.22V8.33c0-1.78 1.44-3.22 3.22-3.22s3.22 1.44 3.22 3.22v6.44zM85.57 14.77c0 1.78-1.44 3.22-3.22 3.22s-3.22-1.44-3.22-3.22V8.33c0-1.78 1.44-3.22 3.22-3.22s3.22 1.44 3.22 3.22v6.44zM92.01 11.56h6.44c3.55 0 6.44 1.27 6.44 4.83v9.65M43.74 11.56H72.7M23.91 38.8h5.36M44.45 38.8h5.36M65.01 38.8h5.36M85.48 38.8h5.37M65.01 68.8h5.36M44.45 53.8h5.36M65.01 53.8h5.36M85.48 53.8h5.37M11.56 26.04v-8.05c0-3.55 2.88-6.44 6.44-6.44h6.44" />
      <path id="bell" d="M43.63 75.92c0 6.85 1.81 13.71 5.76 19.28l.5.73c.73 1.07-.03 2.52-1.32 2.52H6.72c-1.29 0-2.05-1.45-1.32-2.52l.5-.73c3.96-5.57 5.76-12.43 5.76-19.28V72.7c0-8.89 7.15-16.09 15.98-16.09s15.98 7.2 15.98 16.09v3.22h.01ZM27.65 53.39v3.22M22.82 98.45v1.61c0 2.67 2.16 4.83 4.83 4.83s4.83-2.16 4.83-4.83v-1.61" />
  </g>
</svg>
 );
}